const languageSwitcherOpenClass = 'language-switcher--expanded';
let isExpanded = false;

const languageSwitcherInit = (languageSwitcher, languagesList) => {
  if (languageSwitcher == null || languagesList == null) return;

  const activeElement = languagesList.firstElementChild;

  // add click listener
  languageSwitcher.addEventListener('click', () => {
    languagesList.style.height = isExpanded
      ? `${activeElement.clientHeight}px`
      : `${languagesList.scrollHeight}px`;

    languageSwitcher.classList.toggle(languageSwitcherOpenClass);
    isExpanded = !isExpanded;
  });

  // close on click outside
  document.addEventListener('click', (event) => {
    if (isExpanded && !languageSwitcher.contains(event.target)) {
      languagesList.style.height = `${activeElement.scrollHeight}px`;
      languageSwitcher.classList.remove(languageSwitcherOpenClass);
      isExpanded = false;
    }
  });
};

export default languageSwitcherInit;
